import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton } from '@mui/material';

interface Props {
  title: string;
  onBackClick: () => void;
}

export function DialogTitleWithBackButton({ title, onBackClick }: Props) {
  return (
    <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton sx={{ marginRight: 1 }} onClick={onBackClick}>
        <ArrowBackIcon />
      </IconButton>

      {title}
    </Box>
  );
}
